define([
	"dojo/_base/declare",
	"dojo/dom-construct",
	"csi/heading/Number",
	"csi/locale",
	"csi/store/PageSize",
	"csi/widget/InlineSelect"
], function(declare,construct,NumberRen,locale,PageSize,InlineSelect) {

	return declare(NumberRen, {
		formatValue: function(/*Any*/value, /*String?*/fmt) {
			return (value == 0) ? locale.resource("PAGE_ALL") : this.inherited(arguments);
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: create store for page size values and select control to edit
			if (params.value == null) {
				params.value = this._getValue(ctx, h);
			}

			params.store = params.store || ctx.view.querySizeStoreForCustomView;
			params.value = (params.value == null) ? "" : String(params.value);

			return new InlineSelect(params);
		},

		fromHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*InlineSelect*/editNode) {
			// summary: return attribute value from edit control
			return Number(this.getEditorValue(ctx, editNode));
		},

		toHtmlQueryFilter: function(/*Context*/ctx, /*Spec*/spec, /*DOMNode*/refNode, /*Object*/params, /*String*/op) {
			// summary: some custom views still have PageSize=All, so when filtering allow All value to be selected
			params.store = PageSize;
			return this.inherited(arguments, [ctx, spec, refNode, params, op]);
		},

		_getAction: function() {
			// summary: need to set id explicitly to use base action and controller
			var	a = this.inherited(arguments);
			a.classController = "csi.heading.SelectController";
			return a;
		}
	});
});